namespace $ {

	/** Passive subscriptions retain warm projections, not a hidden render loop. */
	export class $shm_hitalama_map_retain extends $mol_object {
		catalog() { return null as unknown as $.$$.$shm_hitalama_map_catalog }
		active_id() { return '' }
		private profile = ''
		private entries = new Map< string, $mol_wire_pub_sub >()
		private renders = new Map< string, $shm_hitalama_map_retain_lease >()

		retained_ids() { return [ ...this.entries.keys() ] }

		release( id: string ) {
			this.renders.get( id )?.destructor()
			this.renders.delete( id )
			this.entries.get( id )?.destructor()
			this.entries.delete( id )
		}

		clear() { for( const id of this.entries.keys() ) this.release( id ) }

		/** Foreground reads establish normal reactive wake-up; the second reads only pin their caches. */
		reconcile() {
			const catalog = this.catalog()
			const profile = catalog.profile()?.link().str ?? ''
			if( profile !== this.profile ) { this.clear(); this.profile = profile }
			if( !profile ) return
			const favorites = new Set( catalog.favorite_ids() )
			for( const id of this.entries.keys() ) if( !favorites.has( id ) ) this.release( id )
			const id = this.active_id()
			if( !id || !favorites.has( id ) ) return
			const book = catalog.Book( id )
			if( !book.map().can_read() ) { this.release( id ); return }
			const page = book.Map_page() as $.$$.$shm_hitalama_map_page
			page.widgets_view()
			let subscriber = this.entries.get( id )
			if( !subscriber ) {
				subscriber = new $mol_wire_pub_sub( `${ this }.map(${ id })` )
				this.entries.set( id, subscriber )
			}
			const previous = subscriber.track_on()
			try {
				catalog.Book( id )
				book.Map_page()
				page.widgets_view()
			} finally {
				subscriber.track_cut()
				subscriber.track_off( previous )
			}
			// The normal renderer publishes this handle. Subscribe without calling
			// render()/dom_tree() again, including when that renderer is suspended.
			const render = page.render_publisher
			if( render && !this.renders.get( id )?.matches( render ) ) {
				this.renders.get( id )?.destructor()
				this.renders.set( id, new $shm_hitalama_map_retain_lease( render ) )
			}
		}

		destructor() { this.clear(); super.destructor() }
	}
}
